/** Routenpfade der Anwendung, die Navigation und Rücksprungziele vergleichen. */
export const ROUTE_ROOT = "/";
export const ROUTE_ADMIN = "/admin";
export const ROUTE_ADMIN_LOGIN = "/admin/login";
export const ROUTE_ADMIN_SETTINGS = "/admin/settings";
export const ROUTE_ADMIN_IMPORT = "/admin/import";
export const ROUTE_ADMIN_IMPORT_RUNS = "/admin/import/runs";
export const ROUTE_ADMIN_IMPORT_ADAPTERS = "/admin/import/adapters";
export const ROUTE_ADMIN_IMPORT_MERGES = "/admin/import/merges";
export const ROUTE_TOOLS = "/tools";
export const ROUTE_BILLING = "/billing";
export const ROUTE_REPORTS_LISTS = "/reports/lists";
export const ROUTE_FINANCE = "/finance";
export const ROUTE_FINANCE_SEPA_DIRECT_DEBIT_RUNS = "/finance/sepa-direct-debit-runs";
export const ROUTE_FINANCE_SEPA_DIRECT_DEBIT_RUNS_CREATE = "/finance/sepa-direct-debit-runs/create";
export const ROUTE_COMMUNICATION = "/communication";
export const ROUTE_LEADS = "/leads";
export const ROUTE_MEMBER_CARE_DUE = "/member-care/due";
export const ROUTE_SALES = "/sales";
export const ROUTE_STAFF = "/staff";
export const ROUTE_SETTINGS_APPOINTMENT_CONFIGURATION = "/settings/appointment-configuration";
export const ROUTE_CANCEL_BOOKING = "/cancel-booking";
